export const ratingFilterList = [
  { id: 0, name: '1 estrela',  value: 1 },
  { id: 1, name: '2 estrelas', value: 2 },
  { id: 2, name: '3 estrelas', value: 3 },
  { id: 3, name: '4 estrelas', value: 4 },
  { id: 4, name: '5 estrelas', value: 5 },
]

export const replyFilterList = [
  { id: 5, name: 'Avaliações sem resposta', value: false },
  { id: 6, name: 'Avaliações respondidas',  value: true },
]

export default {
  ratingFilterList,
  replyFilterList
}